/* Inspection photos as the follow-up / Calls pages list them: [{ section, src }] */

// attic photo slots → the section names staff and the follow-up page see
const PHOTO_SECTION = {
  depth: 'Depth ruler',
  overview: 'Attic overview',
  soffit: 'Soffits',
  airSealing: 'Air sealing',
  hatch: 'Attic hatch',
  exhaust: 'Exhaust',
  mold: 'Mould',
  pest: 'Pest',
};

export const collectPhotos = (frontPhoto, atticData) => [
  ...(frontPhoto ? [{ section: 'Front of home', src: frontPhoto }] : []),
  ...Object.entries((atticData && atticData.photos) || {}).flatMap(([key, list]) =>
    (list || []).map((src) => ({ section: PHOTO_SECTION[key.split('-')[0]] || key, src }))
  ),
];

